export interface Education {
    semisId: number;
    id: number;
    uid: string;
    title: string;
    address: string;
    startDate: string;
    endDate: string;
    county: string;
    measure: string;
    remark: string;
    expertArea: string;
    educationCategory: string;
    educationStatuses: EducationStatus[];
    educationReminders: number[];
    typeOfOperation: string;
    instructors: {
        name: string;
    }[];
    timeDetails: {
        dateFrom: string;
        dateTo: string;
    }[];
    maxAttendees: number;
    spotsAvailable: number;
    registrationDeadline: string;
    isEducationMandatoryForFarmer: boolean | null;
    isActive: boolean;
}

export enum EducationStatusId {
    Available = 0,
    Applied = 1,
    Listened = 2,
    Reminder = 3,
}

export const STATUS_TITLES: Record<EducationStatusId, string> = {
    [EducationStatusId.Available]: "Dostupni",
    [EducationStatusId.Applied]: "Prijavljeni",
    [EducationStatusId.Listened]: "Odslušali",
    [EducationStatusId.Reminder]: "Prijavljeni", // reminders are only possible for applied educations
};

export interface EducationStatus {
    uid: string;
    farmerLastName: string;
    farmerName: string;
    mibpg: string;
    semisId: number;
    status: string;
    statusId: EducationStatusId;
}

export interface FarmHolderItem {
    firstName: string;
    lastName: string;
    oib: string;
    memberType: string;
    farmerId: number;
}

export interface MeasuresResponse {
    measures: string[];
}

export interface OperationTypesResponse {
    operationTypes: string[];
}

export interface ExpertAreasResponse {
    expertAreas: string[];
}

export interface EducationApplicationResponse {
    response: {
        success: boolean;
        notice: string[];
    };
}

export interface EducationReminderRequest {
    educationId: number;
    accountUid: string;
    educationUid: string;
    remindInDays: number[];
    mibpg: string;
}

export interface AddRemoveEducationReminder {
    educationId: string;
    remindInDays: number[];
}

export interface EducationReminderFromResponse {
    uid: string;
    educationId: number;
    accountUid: string;
    education: Education;
    educationUid: string;
    remindInDays: number;
    createdAt: string | null;
    updatedAt: string | null;
    isActive: true;
    isDeleted: true;
}

export interface EducationReminderResponse {
    educationReminders: EducationReminderFromResponse[];
}

export interface Farmer {
    farmerId: number;
    uid: string;
    firstName: string;
    lastName: string;
    oib: string;
    memberType: string;
}

export interface FarmerObligations {
    measure: string;
    educationName: string;
    entryYear: Date;
    done: number;
}

export interface FarmHolderResponse {
    farmHolder: Farmer;
}

export interface FarmMembersResponse {
    farmMembers: Farmer[];
}

export interface RegistryResponse {
    id: number;
    parentId: number;
    name: string;
}

export interface EducationsResponse {
    educationsList: Education[];
    educationsCount: number;
}

export interface FarmerObligationsResponse {
    farmerObligations: FarmerObligations[];
}

export interface GetEducationsByTitlesAndCountyResponse {
    educations: {
        [key: string]: Education[];
    };
}
